<template>
  <el-dialog
      ref="orderInfo"
      :title=" '【' + info.orderNo + '】' + ' 订单详情'"
      :close-on-click-modal="false"
      :visible.sync="visible"
      width="68%">
    <div class="order-contain">
      <div class="order-info">
        <span class="title">状态信息</span>
        <el-form :inline="true" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="订单编号:">
                {{ info.orderNo }}
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="订单状态:">
                <el-tag size="mini"> {{ info.orderStatus | statusFilters }}</el-tag>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="order-info">
        <span class="title">乘客信息</span>
        <el-form :inline="true" label-width="130px">
          <el-row :gutter="28">
            <el-col :span="8">
              <el-form-item label="出发地:">
                {{ info.startAddress }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="目的地:">
                {{ info.endAddress }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预计出发时间:">
                {{ info.orderDepart }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="28">
            <!--            <el-col :span="8">-->
            <!--              <el-form-item label="预计到达时间:">-->
            <!--                {{ info.orderArrive }}-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <el-col :span="8">
              <el-form-item label="公里数:">
                {{ info.distance }} 公里
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预计出行人数:">
                {{ info.passengerNumber }} 人
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="乘车人姓名：">
                {{ info.passengerName}}
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="乘车人电话：">
                {{ info.passengerPhone }}
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="下单人姓名：">
                {{ info.userName }}
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="下单人电话：">
                {{ info.userPhone }}
              </el-form-item>
            </el-col>

          </el-row>

          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="备注:">
                {{ info.orderRemark }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="order-info">
        <span class="title">支付信息</span>
        <el-form :inline="true" label-width="110px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="支付时间:">
                {{ info.paySuccessTime }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预付金额:">
                {{ info.payAmount }} 元
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="接单金额:">
                {{ info.acceptOrderAmount }} 元
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="差价退款金额:">
                {{ info.systemRefundAmount }} 元
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="支付渠道:">
                <el-tag size="mini">{{ info.payType | payTypeFilters }}</el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手动退款金额:">
                {{ info.adminRefundAmount }} 元
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="订单余额:">
                {{ info.surplusAmount }} 元
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="order-info">
        <span class="title">服务信息</span>
        <div style="padding: 10px 0 0 20px">
          <el-table
              :data="info.driverOperationInfoList"
              border
              style="width: 100%">
            <el-table-column label="供应商信息" prop="merchantName"></el-table-column>
            <el-table-column label="司机姓名" prop="driverName"></el-table-column>
            <el-table-column label="司机手机号码" prop="driverPhone"></el-table-column>
            <el-table-column label="车牌号" prop="plateNumber"></el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-tag size="mini">{{ scope.row.operationStatus | serviceStatusFilter }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="operationRemark"></el-table-column>
          </el-table>
        </div>
      </div>

      <div class="order-info">
        <span class="title">退款信息</span>
        <div style="padding: 10px 0 0 20px">
          <el-table
              :data="info.orderRefundInfoList"
              border
              style="width: 100%">
            <el-table-column label="编号" prop="orderNo" width="130" align="left"></el-table-column>
            <el-table-column label="退款时间" prop="successTime" width="180" align="center"></el-table-column>
            <el-table-column label="退款金额" prop="refundAmount" width="100" align="center"></el-table-column>
            <el-table-column label="退款类型" prop="source" width="120" align="center">
              <template slot-scope="scope">
                <el-tag size="mini">{{ scope.row.source | serviceStatusFilter }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="违约金" prop="serviceCharge" width="80" align="center"></el-table-column>
            <el-table-column label="操作人" prop="createUserName" width="80" align="center"></el-table-column>
            <el-table-column label="备注" prop="remark" align="center"></el-table-column>
          </el-table>
        </div>
      </div>

      <div class="order-info">
        <span class="title">开票信息</span>
        <el-form :inline="true" label-width="110px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="开票状态:">
                {{ info.invoiceStatus }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票金额:">
                {{ info.invoiceAmount }} 元
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票时间:">
                {{ info.invoiceCreateTime }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="开票类型:">
                {{ info.invoiceType }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票信息:">
                {{ info.invoiceInfo }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import { getOrder } from '@/api/order'
  export default {
    name: "orderDetailsStatis",
    filters: {
      statusFilters(orderStatus){
        let mark = ''
        switch (orderStatus) {
          case 1:
            mark = '待支付'
            break
          case 2:
            mark = '待接单'
            break
          case 3:
            mark = '待出发'
            break
          case 4:
            mark = '取消'
            break
          case 5:
            mark = '接人中'
            break
          case 6:
            mark = '待乘客上车'
            break
          case 7:
            mark = '行程中'
            break
          case 8:
            mark = '送达完成'
            break
          case 9:
            mark = '已退款'
            break
        }
        return mark;
      },
      // 支付类型过滤
      payTypeFilters(payType){
        let mark = ''
        switch (payType) {
          case 1:
            mark = '通联支付'
            break
        }
        return mark;
      },
      // 服务状态过滤
      serviceStatusFilter(operationStatus) {
        let mark = ''
        switch(operationStatus) {
          case 1:
            mark = '接单'
            break
          case 2:
            mark = '出发接乘客'
            break
          case 3:
            mark = '待乘客上车'
            break
          case 4:
            mark = '取消'
            break
          case 5:
            mark = '行程中'
            break
          case 6:
            mark = '已完成'
            break
        }
        return mark;
      },
      // 渠道状态
      sourceStatusFilter(source) {
        let mark = ''
        switch (source) {
          case 1:
            mark = '乘客退款'
            break
          case 2:
            mark = '后台退款'
            break
          case 3:
            mark = '系统自动退款'
            break
        }
        return mark
      },
    },
    data() {
      return {
        visible: true,
        info: { // 订单信息
          orderNo: ''
        },
      }
    },
    methods: {
      // 初始化数据
      init(row) {
        getOrder(row.orderNo).then(resp => {
          if (resp.code === 0) {
            this.info = resp.data
          }
        })
        this.visible = true
      },
    }
  }
</script>

<style lang="scss" scoped>
  .order-contain {
    width: 100%;
    flex: 1;
    padding: 0;
    margin: 0;

    .or-steps {
      display: flex;
      justify-content: space-between;
    }
    .tk_btn {
      position: absolute;
      top: 22px;
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      left: -90px;
    }
    .title {
      font-size: 16px;
      font-weight: 800;
    }
    .order-info {
      margin-top: 18px;
    }
  }
  .pl{
    padding-left: 10px;
  }
  ::v-deep .el-step__title {
    font-size: 14px;
    line-height: 38px;
  }
  ::v-deep .el-step__description {
    padding-right: 37%;
    margin-top: -4px;
    font-size: 8px;
    line-height: 20px;
    font-weight: 400;
  }
  ::v-deep .el-form-item {
    margin-bottom: 4px !important;
  }
</style>
